export default __webpack_public_path__ + "static/media/misc.824cc427.svg";